export const csvParseLine = (line) => {
    const cells = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
        const ch = line[i];
        if (inQuotes) {
            if (ch === '"') {
                const next = line[i + 1];
                if (next === '"') { current += '"'; i++; }
                else { inQuotes = false; }
            } else { current += ch; }
        } else {
            if (ch === ',') { cells.push(current); current = ''; }
            else if (ch === '"') { inQuotes = true; }
            else { current += ch; }
        }
    }
    cells.push(current);
    return cells;
};

export const validateResultsCsv = (csvText) => {
    if (typeof csvText !== 'string' || csvText.length === 0) return { ok: false, reason: 'Empty CSV' };
    let text = csvText;
    if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
    const lines = text.split(/\r?\n/).filter(l => l.length > 0);
    if (lines.length === 0) return { ok: false, reason: 'No rows' };
    const headerCells = csvParseLine(lines[0]);
    const lower = headerCells.map(h => String(h).trim().toLowerCase());
    const isLongFormat = lower.includes('variable_name');
    const isWideFormat = lower.includes('recipient_id') && lower.includes('email') && !lower.includes('variable_name');
    if (!isLongFormat && !isWideFormat) return { ok: false, reason: 'Unrecognized CSV format (expected Long or Wide)' };
    if (isLongFormat) {
        for (const req of ['recipient_id', 'email', 'variable_name', 'created_at']) {
            if (!lower.includes(req)) return { ok: false, reason: `Missing required column: ${req}` };
        }
        // Accept either value_json (legacy) or answer_text (current)
        if (!lower.includes('value_json') && !lower.includes('answer_text')) {
            return { ok: false, reason: 'Missing required column: answer_text (or value_json)' };
        }
    } else {
        for (const req of ['recipient_id', 'email']) {
            if (!lower.includes(req)) return { ok: false, reason: `Missing required column: ${req}` };
        }
    }
    const width = headerCells.length;
    const tsIndex = lower.indexOf('created_at');
    const varIndex = lower.indexOf('variable_name');
    const isoRe = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/;
    for (let i = 1; i < Math.min(lines.length, 201); i++) {
        const cells = csvParseLine(lines[i]);
        if (cells.length !== width) return { ok: false, reason: `Inconsistent column count at row ${i + 1}` };
        if (tsIndex >= 0) {
            const ts = cells[tsIndex] || '';
            if (ts && !isoRe.test(ts)) return { ok: false, reason: `Timestamp not ISO8601 with timezone at row ${i + 1}` };
        }
    }
    let hasUserName = false;
    if (varIndex >= 0) {
        for (let i = 1; i < Math.min(lines.length, 2001); i++) {
            const cells = csvParseLine(lines[i]);
            if ((cells[varIndex] || '').trim() === 'userName') { hasUserName = true; break; }
        }
    }
    return { ok: true, hasUserName };
};

export const downloadTextFile = (text, filename, mime = 'text/csv;charset=utf-8') => {
    const blob = new Blob([text], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
